const isInteger = value => /^\+?\d+$/.test(value);

export default isInteger;
